import styled from '@emotion/styled';
import { Flex } from '@pairy/pds-react';

export const Wrapper = styled.div`
  min-height: 100vh;
  background-color: ${({ theme }) => theme.colors.zinc_50};
`;

export const InnerWrapper = styled(Flex)`
  width: 1080px;
  margin: 0 auto;
`;

export const NavWrapper = styled.div`
  padding-top: 70px;
  margin-bottom: 16px;
`;

export const Main = styled.main<{
  isReverseGridTemplateColumns: boolean;
  hasNav: boolean;
}>`
  display: grid;
  ${({ hasNav }) => hasNav && `padding-top: 70px;`}
  padding-bottom: 48px;
  column-gap: 16px;
  ${({ isReverseGridTemplateColumns }) =>
    isReverseGridTemplateColumns
      ? `
      grid-template-columns: 715px 349px;
    `
      : `
      grid-template-columns: 349px 715px;
      `}
`;
